module.exports = __webpack_public_path__ + "static/media/certificate.2e765233.jpg";